import { render, staticRenderFns } from "./KnowledgeItem.vue?vue&type=template&id=05cfa064"
import script from "./KnowledgeItem.vue?vue&type=script&lang=js"
export * from "./KnowledgeItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports